module.exports = __webpack_public_path__ + "img/i-meeple-gold.0d032a51.svg";